import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackViewedOnboardingUpload.meta';

export const useTrackViewedOnboardingUpload = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedOnboardingUpload = useCallback(() => {
    track(META.name, undefined, { integrations: { Intercom: true } });
  }, [track]);

  return { trackViewedOnboardingUpload };
};
